import { AutomationEventTypes } from '@tokeet-frontend/automations'

export const userInventoryNotificationMessages = {
  [AutomationEventTypes.InventoryCreated]: {
    subject: 'New Inventory Item Created – *|INVENTORY:NAME|*',
    message: `
      Hi Team,

      A new inventory item has been added to the system.

      Details:
      Item Name: *|INVENTORY:NAME|*
      Description: *|INVENTORY:DESCRIPTION|*

      Please review the item and ensure it is appropriately categorized and tracked.
      `,
  },
  [AutomationEventTypes.InventoryUpdated]: {
    subject: 'Inventory Item Updated – *|INVENTORY:NAME|*',
    message: `
      Hi Team,

      An inventory item has been updated in the system.

      Details:
      Item Name: *|INVENTORY:NAME|*
      Description: *|INVENTORY:DESCRIPTION|*

      Please review the item and ensure it is appropriately categorized and tracked.
      `,
  },
  [AutomationEventTypes.InventoryDeleted]: {
    subject: 'Inventory Item Deleted – *|INVENTORY:NAME|*',
    message: `
      Hi Team,

      An inventory item has been removed from the system.

      Details:
      Item Name: *|INVENTORY:NAME|*
      Description: *|INVENTORY:DESCRIPTION|*

      If this deletion was unintentional, please contact the team immediately for recovery options.
      `,
  },
  [AutomationEventTypes.InventoryDamaged]: {
    subject: 'Inventory Item Marked as Damaged – *|INVENTORY:NAME|*',
    message: `
      Hi Team,

      An inventory item has been reported as damaged.

      Details:
      Item Name: *|INVENTORY:NAME|*
      Description: *|INVENTORY:DESCRIPTION|*

      Please assess the damage and take appropriate actions to repair or replace the item.
      `,
  },
  [AutomationEventTypes.InventoryInoperable]: {
    subject: 'Inventory Item Marked as Inoperable – *|INVENTORY:NAME|*',
    message: `
      Hi Team,

      An inventory item has been marked as inoperable and may require immediate attention.

      Details:
      Item Name: *|INVENTORY:NAME|*
      Description: *|INVENTORY:DESCRIPTION|*

      Please review the item's status and determine the next steps, such as replacement or disposal.
      `,
  },
}

export const guestInventoryNotificationMessages = {}
